import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Repairer } from 'app/_models/repairers';
import { RepairerService } from 'app/_services/repairers.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, finalize } from 'rxjs/operators';

export class RepairerDataSource implements DataSource<Repairer> {

    private repairersSubject = new BehaviorSubject<Repairer[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();

    constructor(private _repairerService: RepairerService) { }

    loadCustomerRepairer(customerId: number) {
        this.loadingSubject.next(true);

        this._repairerService.getRepairers(customerId).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe((repairers: Repairer[]) => {
            this.repairersSubject.next(repairers);
        });
    }

    findById(id: number): Repairer | null {
        const repairers = this.repairersSubject.value;
        return repairers.find(rep => rep.id === id) || null;
    }

    getAll(): Repairer[] {
        return this.repairersSubject.value;
    }

    connect(collectionViewer: CollectionViewer): Observable<Repairer[]> {
        console.log("Connecting Vehicles Admin data source");
        return this.repairersSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.repairersSubject.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-repairers/repairers.datasource.ts